<template>
  <div class="tower_manager">
    <el-form ref="form" :model="form" class="form_wrapper" label-width="120px">
      <div class="form_item">
        <el-form-item label="测风塔编号">
          <el-input
            v-model="form.towerCode"
            placeholder="请输入编号"
            v-if="isEdit"
          ></el-input>
          <div v-else class="form_value">{{ form.towerCode }}</div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="解析密码">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            v-if="isEdit"
          ></el-input>
          <div v-else class="form_value">{{ form.password }}</div>
        </el-form-item>
      </div>
      <div div class="form_item">
        <el-form-item label="经纬度">
          <template v-if="isEdit">
            <el-input v-model="form.lon" placeholder="请输入经度" class="first">
              <span slot="suffix" class="suffix">N</span>
            </el-input>
            <el-input v-model="form.lat" placeholder="请输入维度">
              <span slot="suffix" class="suffix">E</span>
            </el-input>
          </template>
          <div v-else class="form_value">
            <span>{{ form.lon }}N， </span>
            <span>{{ form.lat }}E</span>
          </div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="所在省市">
          <!-- <template v-if="isEdit">
            <el-select
              v-model="form.region"
              placeholder="请选择省"
              class="first"
            >
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
            <el-select v-model="form.region" placeholder="请选择市">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </template> -->
          <div class="form_value">{{ form.address }}</div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="测量开始日期">
          <div class="form_value">{{ form.startDate }}</div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="测量结束日期">
          <div class="form_value">{{ form.endDate }}</div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="风速传感器高度">
          <div class="form_value">
            {{ form.windSpeed ? form.windSpeed + 'm' : '' }}
          </div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="风向传感器高度">
          <div class="form_value">
            {{ form.windDirection ? form.windDirection + 'm' : '' }}
          </div>
        </el-form-item>
      </div>
      <div class="form_item">
        <el-form-item label="海拔">
          <el-input
            v-model="form.altitude"
            placeholder="请输入海拔"
            v-if="isEdit"
          >
            <span slot="suffix" class="suffix">米</span>
          </el-input>
          <div class="form_value" v-else>{{ form.altitude }}米</div>
        </el-form-item>
      </div>
      <!-- <div class="form_item">
        <el-form-item label="塔高">
          <div class="form_value">{{ form.height }}米</div>
        </el-form-item>
      </div> -->
      <!-- <div class="form_item">
        <el-form-item label="所属项目">
          <el-input
            v-model="form.projectName"
            placeholder="请输入所属项目"
            v-if="isEdit"
          >
          </el-input>
          <div class="form_value" v-else>{{ form.projectName }}</div>
        </el-form-item>
      </div> -->
      <div class="form_item">
        <el-form-item label="创建者">
          <!-- <el-input v-model="form.createUserName" placeholder="请输入创建者">
          </el-input> -->
          <div class="form_value">{{ form.createUserName }}</div>
        </el-form-item>
      </div>
    </el-form>
    <div class="save_btn" v-if="ifUpdate == 1">
      <ct-button type="primary" :btn-click="save" v-if="isEdit">保存</ct-button>
      <ct-button :btn-click="modify" v-else>修改</ct-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: function() {
        return {};
      }
    },
    ifUpdate: {
      type: Number
    }
  },
  computed: {
    towerInfo() {
      return this.$store.state.WindData.towerObj;
    }
  },
  data() {
    return {
      isEdit: false
    };
  },
  mounted() {
    // this.getCity();
  },
  methods: {
    modify() {
      this.isEdit = true;
    },
    async save() {
      let {
        towerCode,
        password,
        lat,
        lon,
        altitude,
        projectName,
        height,
        createTime
      } = this.form || {};
      let { towerId } = this.towerInfo || {};
      if (towerCode.length > 20 || towerCode == '') {
        return this.$message.error(
          '测风塔编号不能为空，且长度不能超过20个字。'
        );
      }
      if (password.length > 20) {
        return this.$message.error('解析密码长度不能超过20个字。');
      }
      if (!this.checkLatOrLon(lon, '经度')) return;
      if (!this.checkLatOrLon(lat, '纬度')) return;
      if (isNaN(altitude)) {
        return this.$message.error('海拔高度' + altitude + '不是数字');
      }
      if ((projectName || '').length > 100) {
        return this.$message.error('所属项目名称不能超过100个字');
      }
      lat = (+lat).toFixed(6);
      lon = (+lon).toFixed(6);
      altitude = (+altitude).toFixed(1);
      let res = await this.$postForm('/winddata/tower/updateTower', {
        module: 'windData',
        showError: true,
        method: 'post',
        showLoading: { mask: true },
        data: {
          lat,
          lon,
          projectName,
          towerId,
          altitude,
          height,
          password,
          setupDate: createTime,
          towerCode
        }
      });
      if (res.code == 0) {
        this.isEdit = false;
        let modifyStatus = this.$store.state.WindData.modifyStatus;
        this.$emit('update', res.data.tower);
        this.$store.commit('WindData/SET_MODIFYSTATUS', !modifyStatus);
      }
    },
    checkLatOrLon(value, type) {
      let min = -90;
      let max = 90;
      if (type === '经度') {
        min = -180;
        max = 180;
      }
      if (isNaN(value)) {
        return this.$message.error(type + value + '不是数字');
      } else if (value > max || value < min) {
        return this.$message.error(`${type}必须在${min}到${max}之间`);
      } else if (
        value.toString().split('.').length > 0 &&
        value.toString().split('.')[1].length > 6
      ) {
        return this.$message.error('小数最多为6位');
      }
      return true;
    },
    getCity(parentId) {
      this.$fetch('/winddata/tower/getRegionList', {
        module: 'windData',
        params: {
          parentId: parentId || ''
        }
      });
    }
  }
};
</script>

<style lang="less">
.tower_manager {
  .save_btn {
    text-align: right;
    padding-top: 20px;
    span:first-child {
      margin-right: 20px;
    }
  }
  .el-form-item__label {
    text-align: left !important;
    position: relative;
    &:after {
      content: ':';
      margin-right: 10px;
      display: inline-block;
      position: absolute;
      right: -5px;
    }
  }
  .el-input__suffix-inner {
    font-size: 14px;
    font-weight: bold;
    color: #222234;
  }
  .form {
    &_wrapper {
      // display:flex;
      display: flex;
      flex-wrap: wrap;
      background: #fff;
      padding-top: 16px;
      padding-left: 30px;
    }
    &_item {
      display: inline-block;
      width: 50%;
      padding-right: 30px;
      box-sizing: border-box;
      display: flex;
      .first {
        margin-right: 10px;
      }
    }
    &_value {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
    }
  }
  .el-form-item {
    display: flex;
    width: 100%;
  }
  .el-select {
    flex: 1;
  }
  .el-form-item {
    margin-bottom: 10px !important;
  }
  .el-form-item__content {
    display: flex;
    flex: 1;
    margin-left: 0 !important;

    input {
      border: 0;
      background: rgb(240, 245, 250);
      font-size: 14px;
      font-weight: bold;
    }
    input::-webkit-input-placeholder {
      font-size: 14px;
      color: #aaaabcff;
      font-weight: bold;
    }
  }
  .el-form-item__label {
    font-size: 14px;
    color: #222234ff;
    font-weight: bold;
  }
}
</style>
